/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { InlineNotification } from '@coursera/cds-core';

import { allowedFileTypesForAiGrading } from 'bundles/grading-common/utils/constants';
import { useAiGradingContext } from 'bundles/peer/components/ai-grading/AiEligibilityProvider';

import _t from 'i18n!nls/grading-common';

type Props = {
  filename?: string;
};

const styles = {
  marginBottom: () => css`
    margin-top: var(--cds-spacing-150);
  `,
};

const UnsupportedFileForAiGradingNotification = ({ filename }: Props) => {
  const { isAiGradingFlowPreview } = useAiGradingContext();
  const isAiGradingFlow = isAiGradingFlowPreview();
  const isSupportedFile = Object.values(allowedFileTypesForAiGrading).includes(
    filename?.split('.').pop()?.toLowerCase() || ''
  );
  if (isAiGradingFlow && filename && !isSupportedFile) {
    return (
      <InlineNotification
        severity="warning"
        css={styles.marginBottom}
        title={_t("This file type can't be graded by AI")}
      >
        {_t(
          'Your assignment will be graded by your peers because your file type isn’t supported by AI grading. If you would like to switch to AI grading, upload another file.'
        )}
      </InlineNotification>
    );
  }

  return null;
};

export default UnsupportedFileForAiGradingNotification;
